<template>
  <div class="flex items-center p-6 pt-0">
    <slot></slot>
  </div>
</template> 